import { useNavigate, useLocation } from "react-router-dom";
import { FolderIcon, LayersIcon, Logo, PlusIcon, SettingsIcon } from "../Components/Icons";
import { APP, canEdit } from "../constants.js";
import "./Sidebar.css";

const navItems = [
  { path: "/brands", label: "Brands", icon: FolderIcon },
  { path: "/assets", label: "Assets", icon: LayersIcon },
  { path: "/usage", label: "Usage", icon: SettingsIcon },
];

export default function Sidebar({ workspaceName, role }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <Logo className="sidebar__brand-logo" />
        <span className="sidebar__brand-name">{APP.NAME}</span>
      </div>

      <div className="sidebar__workspace">
        <p className="sidebar__workspace-label">Workspace</p>
        <p className="sidebar__workspace-name">{workspaceName}</p>
      </div>

      <nav className="sidebar__nav" aria-label="Main">
        {canEdit(role) ? (
          <button type="button" onClick={() => navigate("/generate")} className="sidebar__new-asset">
            <PlusIcon className="sidebar__new-asset-icon" />
            New asset
          </button>
        ) : null}

        {navItems.map((item) => {
          const active = location.pathname.startsWith(item.path);
          return (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              aria-current={active ? "page" : undefined}
              className={`sidebar__nav-item${active ? " sidebar__nav-item--active" : ""}`}
            >
              <item.icon
                className={`sidebar__nav-icon${active ? " sidebar__nav-icon--active" : ""}`}
              />
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="sidebar__footer">
        <p className="sidebar__footer-text">HTML5 Display Studio</p>
      </div>
    </aside>
  );
}